import { InsightsProvider } from "@/contexts/insights-context";
import { InsightsLocationNav, InsightsLocationNavMobile } from "./insights-location-nav";

interface InsightsLayoutProps {
  children: React.ReactNode;
}

export function InsightsLayout({ children }: InsightsLayoutProps) {
  return (
    <InsightsProvider>
      {/* h-full ensures overflow-auto on the scroll container constrains height
         on all viewports, enabling sticky nav positioning */}
      <div className="flex h-full">
        <InsightsLocationNav />
        <div className="flex-1 min-w-0 overflow-auto" data-insights-scroll-container>
          {children}
        </div>
      </div>
    </InsightsProvider>
  );
}

export function InsightsPageWrapper({ children }: { children: React.ReactNode }) {
  return (
    <div className="pb-6">
      {/* Mobile location selector - shown below page header */}
      <div className="px-4 sm:px-6 pt-4">
        <InsightsLocationNavMobile />
      </div>
      <div className="px-4 sm:px-6">
        {children}
      </div>
    </div>
  );
}
